import HttpUtils from "src/utils/HttpUtils";
import toastService from "./ToastService";

const downloadjs = require("downloadjs");

class NotificationService {
    constructor() {
        this.baseUrl = HttpUtils.getBaseUrl();
    }

    getNotificationByType = async (findNotificationParams) => {
        const requestId = HttpUtils.generateRequestId();
        const requestDescription = "Query Notifications for user";
        const headers = new Headers({
            "Content-Type": "application/json",
            "x-sdd-correlation-id": requestId,
            "x-sdd-correlation-description": requestDescription,
        });
        const response = await window.fetch(
            this.baseUrl + "notification-center",
            {
            method: "POST",
            credentials: "same-origin",
            headers: HttpUtils.amendHeadersIfNeeded(headers),
            body: JSON.stringify(findNotificationParams),
            }
        );
        HttpUtils.reloadIfRedirectedToLogin(response);
        return response.json();
    }
  
    downloadNotificationFile = async (notificationTid, notificationType) => {
        const reqId = HttpUtils.generateRequestId();
        try {
            const requestDescription = "Download notification file";
            HttpUtils.addRequest(reqId, requestDescription);
            const headers = new Headers({
                "x-sdd-correlation-id": reqId,
                "x-sdd-correlation-description": requestDescription,
            });
            const fullUrl =
                this.baseUrl +
                "notification-center/download?notificationTid=" +
                encodeURIComponent(notificationTid) +
                "&notificationType=" +
                encodeURIComponent(notificationType);

            const response = await window.fetch(fullUrl, {
                method: "GET",
                credentials: "same-origin",
                headers: HttpUtils.amendHeadersIfNeeded(headers),
                redirect: "manual",
            });
            HttpUtils.reloadIfRedirectedToLogin(response);

            if (!response.ok || response.status === 500) {
                toastService.func_notify(
                    "Downloading notification file failed. Reason: " + (await response.json().message),
                    "error"
                );
            }
    
            const blob = await response.blob();
    
            const contentDisposition = response.headers.get("content-disposition");
            const fileName = contentDisposition
                ? contentDisposition.split("filename=")[1].replace(/['"]/g, "")
                : "file.xlsx";
    
            downloadjs(blob, fileName);
        } catch (error) {
            console.error("Failed to download notification file: ", error);
        } finally {
            HttpUtils.removeRequest(reqId);
        }
    }
}

const notificationService = new NotificationService();
export default notificationService;